<template>
  <a-modal title="选择数据模式" :width="600" :visible="visible" :confirmLoading="confirmLoading" @cancel="handleCancel">
    <a-spin :spinning="confirmLoading">
      <a-radio-group class="database-ascription" v-model="databaseAscription">
        <a-radio-button value="1">独立数据</a-radio-button>
        <a-radio-button value="2" @click="$refs.bindModal.show(currentRobotId)">互通数据</a-radio-button>
      </a-radio-group>
      <div v-show="databaseAscription == '1'">
        <a-alert :closable="true" type="info" showIcon message="此机器人采用独立数据运行，与账号下其他机器人数据无关联" style="margin-bottom: 24px" />
      </div>
      <div v-show="databaseAscription == '2'">
        <BindModal ref="bindModal" @close="handleCancel"></BindModal>
        <!-- <a-form :form="form">
          <a-alert
            :closable="true"
            type="info"
            showIcon
            message="尊敬的用户您好，为了您的数据安全稳定，如需使用自有数据库，请联系官方技术支持"
            style="margin-bottom: 24px"
          />
          <a-form-item label="数据库主机" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['host', { rules: [{ required: true, message: '必填项' }] }]"
              placeholder="请填写"
              disabled
            />
          </a-form-item>
          <a-form-item label="数据库端口" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['port', { rules: [{ required: true, message: '必填项' }] }]"
              placeholder="请填写"
              disabled
            />
          </a-form-item>
          <a-form-item label="数据库用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['username', { rules: [{ required: true, message: '必填项' }] }]"
              placeholder="请填写root"
              disabled
            />
          </a-form-item>
          <a-form-item label="数据库密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['password', { rules: [{ required: true, message: '必填项' }] }]"
              placeholder="请填写"
              disabled
            />
          </a-form-item>
        </a-form> -->
      </div>
    </a-spin>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button :loading="confirmLoading" type="primary" @click="handleSubmit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
import BindModal from './BindModal.vue'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      databaseAscription: '1'
    }
  },
  components:{
    BindModal
  },
  methods: {
    ...mapGetters(['userInfo']),
    show (currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    handleCancel () {
      this.visible = false
      this.databaseAscription='1'
    },
    handleSubmit (e) {
      e.preventDefault()
      if (this.databaseAscription == '1') {
        this.confirmLoading = true
        const params = {
          sub_id: this.currentRobotId
        }
        DeviceApi
          .saveDbInitUseSys(params)
          .then(res => {
            if (res.code === 1) {
              if (res.code === 1) {
                this.$message.success('创建数据库成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            } else {
              this.$message.error(res.msg)
            }
          })
          .finally(() => {
            this.confirmLoading = false
          })
      } else if (this.databaseAscription == '2') {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            const main_id = this.userInfo().id
            const sub_id = this.currentRobotId
            DeviceApi.saveDbInit({
              sub_id: sub_id,
              main_id: main_id,
              host: values.host,
              port: values.port,
              username: values.username,
              password: values.password
            })
              .then(res => {
                if (res.code === 1) {
                  this.form.resetFields()
                  this.$message.success('创建数据库成功')
                  this.visible = false
                  this.$emit('ok')
                } else {
                  this.$message.error(res.msg)
                }
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.database-ascription {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 24px;
  text-align: center;
  .ant-radio-button-wrapper {
    width: 100%;
  }
}
</style>
